import React from "react";
import { LeadCard, ReasonAndTime, Sec, NextPointer } from "./parts";
import { chaseView, toldUs } from "./leadModel.mjs";

/*
 * NEW LEAD, CHASING: where the chase stands (the brief's row: "Touch 2 of 3 · our
 * last email 5 days ago · next: final check Oct 3"; matrix 1e). Undrawn as a frame,
 * so built in the drawn card grammar on Gabriel's ruling (2026-10-01).
 *
 * The ladder is the server's (act.cadence on act.thresholds, src/actions/model.js
 * cadenceState): after one touch the next rung is a nudge, after two the final
 * check, after three Remove from pipeline. A rung that is due points at its Next
 * line, which owns the button. Once the last rung has gone out the card wears the
 * fade (the brief's mark for "going cold": a dashed border, grey words). Below it,
 * what their form asked for, so the next touch can answer it (an intro email is
 * already the latest conversation, so only a form is repeated), and the reason
 * for the score with their time now, because it is featured until the first call.
 *
 * Props:
 *   record   the shell's bundle: act (cadence, thresholds, facts), timeline.rows,
 *            zones, score, contact, company
 *   ops      ops.toggleBreakdown
 */
export default function Chasing({ record, ops }) {
  const chase = chaseView(record.act, { now: record.now });
  const told = toldUs({ rows: record.timeline.rows, company: record.company, contact: record.contact, zones: record.zones, now: record.now });
  return (
    <LeadCard label="Where the chase stands" className={chase.cold ? "rec-fade" : ""}>
      <div>
        <div className="rec-headline">{chase.headline}</div>
        {chase.next && (
          <div className="rec-body">
            {chase.next}
            {chase.due && (
              <>
                {" "}
                <NextPointer />
              </>
            )}
          </div>
        )}
      </div>
      {told.kind === "form" && told.message && (
        <Sec>
          <span className="rec-lead__small">What they told us{told.meta ? ` · ${told.meta}` : ""}</span>
          <div className="rec-quote rec-quote--md">{told.message}</div>
        </Sec>
      )}
      <ReasonAndTime record={record} ops={ops} mode="why" />
    </LeadCard>
  );
}
